module.exports = __webpack_public_path__ + "static/media/AB_figures_desktop_reseller_2.45c3cfd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AB_figures_desktop_reseller_2.png
// module id = 1102
// module chunks = 0